export enum FileStatus {
  REMOVED = "removed",
  DONE = "done",
}
